var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2253 20.2497H2.75V16.9008C2.75 16.8335 2.77719 16.769 2.8254 16.7219L13.1918 6.60645L16.7502 10.0788L6.39989 20.1786C6.3532 20.2242 6.29054 20.2497 6.2253 20.2497Z",
    stroke: "#007EA9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1407 20.25H21.2499V17.75H14.6617L12.1407 20.25Z",
    fill: "#007EA9",
    stroke: "#007EA9",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8241 9.03109L19.5609 7.33607C19.7411 7.16027 19.7411 6.88578 19.5609 6.70999L16.6703 3.88934C16.4799 3.70354 16.1665 3.70357 15.9761 3.88935L14.2656 5.55874L17.8241 9.03109Z",
    fill: "#007EA9",
    stroke: "#007EA9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOn);
export default __webpack_public_path__ + "static/media/editOn.fd2a047fa1950d1fbe9950a2cb47b76d.svg";
export { ForwardRef as ReactComponent };